import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { getGlobalStyleSheets } from '../../global-styles';
import { ifDefined } from 'lit/directives/if-defined.js';
import * as TagNames from './panels.tagnames';

@customElement(TagNames.MultiTabBody)
export class AtlMultiTabPanelBody extends LitElement {
   static styles = [
      ...getGlobalStyleSheets(),
      css`
         :host {
            display: block;
         }
      `,
   ];

   render() {
      return html`
         <div class="atl-wc-multitab-panel" part="body" tabindex="0">
            <div class="card-body tab-content" part="card" tabindex="0">
               <div
                  id=${ifDefined(this.id)}
                  class="tab-pane fade active show"
                  role="tabpanel"
                  part="pane"
                  ?key=${this.id}
               >
                  <slot></slot>
               </div>
            </div>
         </div>
      `;
   }
}
